import React from "react";
import { Team } from '../components/Team';

const TeamPage = () => (
  <div className="pt-8">
    <Team />
  </div>
);

export default TeamPage;